<template>
  <div id="to-info-component" style="margin-bottom:40px;">
    <v-container :class="'info-section'">
      <v-layout row wrap>
        <v-flex x12 style="display:flex;justify-content:space-between; padding-bottom:16px;">
          <div style="display:flex;align-items:center;">
            <v-btn small icon dark @click="back()">
              <v-icon style="color:#10aa85;">arrow_back</v-icon>
            </v-btn>
            <h2 style="color:#10aa85;font-weight:400;">Paket Belajar  </h2>
          </div>
        </v-flex>
        <v-flex xs12 >
          <v-card style="border-radius:10px; margin:0 auto; height:100px; padding-top:10px;">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 style="display:flex;justify-content:space-between;" >
                  <div style="display:flex;align-items:center;">
                    <img alt="image-alt" src="@/assets/icon/ticket.svg" />
                    <div style="margin-left:10px;">
                        <span style="font-size:13px; line-height:4px;">Tiket Juara</span>
                        <p style="font-size:27px;line-height:1.1;color:#00ADE2;margin:0px;font-weight:bold;" v-if="$store.state.profile.tickets !== 'error' && !loadingTicket">{{ $store.state.profile.tickets.user_tickets}}</p>
                        <div style="margin-top:3px;" v-show="$store.state.profile.tickets == 'error' && !loadingTicket">
                        <span style="font-size:15px;line-height:10px;color:#B2B2B2;display:flex;align-items:center;cursor:pointer;" @click="reloadTicket()">
                            <img alt="image-alt" src="@/assets/icon/icon_reload.svg" style="margin-right:6px;"/>
                            Coba Ulang
                        </span>
                        </div>
                        <div>
                        <v-progress-circular
                            v-if="loadingTicket"
                            indeterminate
                            width="2"
                            size="15"
                            color="primary"
                        ></v-progress-circular>
                        </div>
                    </div>
                  </div>
                    <v-btn round small outline color="#00ADE2" @click="$router.push('/premium')" style="text-transform:capitalize !important;">
                        <v-icon>add</v-icon> &nbsp;
                        Beli
                    </v-btn>
                </v-flex>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="subscribe.length > 0" style="margin-top:40px; padding-bottom:0px;">
      <v-layout row wrap style="margin-bottom:10px;">
        <v-flex xs12>
          <h2>
            Paket Langganan Kamu
          </h2>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 v-for="(item, i) in subscribe" :key="i">
          <v-card style="border-radius: 8px; padding: 12px; margin-bottom:12px;">
            <p style="font-size:18px; margin-bottom:5px;">
              <b>
                {{ item.display_name}}
              </b>
            </p>
            <p>
              Aktif Sampai :
              <span style="color:red;">
                {{ item.expired_at | convDate }}
              </span>
            </p>
            <v-divider>
            </v-divider>
            <v-btn flat medium block color="primary" @click="openFeature(item.scope_name)">Buka Fitur</v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container style="padding-bottom:0px; margin-top:40px;" v-if="notSubscribe.length > 0">
      <v-layout row wrap style="margin-bottom:10px;">
        <v-flex xs12>
          <h2>
            Ayo Langganan Paket Lainnya
          </h2>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 v-for="(item, i) in notSubscribe" :key="i">
          <v-card style="border-radius: 8px; padding: 12px; margin-bottom:12px;">
            <v-layout row wrap>
              <v-flex xs9 style="padding-right:15px;">
                <p style="font-size:18px; margin-bottom:5px;">
                  <b>
                    {{ item.display_name }}
                  </b>
                </p>
                <p>
                  {{ item.description}}
                </p>
              </v-flex>
              <v-flex xs3 style="display:flex; align-items:center;">
                <v-btn medium dark round block color="#10aa85" @click="activatePackage(item.scope_name)">Aktifkan</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="loadinglistPackage" style="display:flex;align-items:center;justify-content:center; height:200px;">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<style>
.theme--light.v-btn-toggle {
    background: #e7e4e4;
    color:white;
    border-radius: 200px;
}
.info-section {
  height: 150px;
  /* margin-bottom: 10px; */
  display: flex;
  align-items: flex-start;
  /* background-image: url('../../assets/icon/bg_profile.svg');
  background-size: 100%; */
  padding: 1em;
  color: #10aa85;
  box-shadow: 0px 0px 4px 0px #c7c7c7;
  /* background-size: cover; */
}

.info-section-dialog {
  height: 70px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  background-image: url('../../assets/icon/bg_profile.svg');
  background-size: 100%;
  padding: 1em;
  color: white;
  background-size: cover;
}
.ic {
  margin-right: 4px;
}
.ava {
  border-radius: 50%;
  width: 100px;
}
.ic-actions {
  margin-right: 15px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 5px;
}

.v-input.searchsearch .v-input__control .v-input__slot {
  /* border-radius:10px !important; */
  border:none !important;
}

.v-expansion-panel__container.ticketexp.v-expansion-panel__container--active{
  border-top: none !important;
}

.v-expansion-panel__container.ticketexp{
  border-top: none !important;
}
</style>

<script>
import moment from 'moment'
moment.locale('id')
/* eslint-disable */
export default {
  name: 'package-study-component',
  components: {
  },
  data: function () {
    return {
      loadingTicket: false,
      subscribe: [],
      notSubscribe: [],
      loadinglistPackage: false,
      listPackage: []
    }
  },
  methods: {
    reloadTicket(){
      var context = this
      this.loadingTicket = true
      this.$store.dispatch('funcGetUserTickets').then(res =>{
        setTimeout(function(){
          context.loadingTicket = false
        }, 1500)
      }).catch(err =>{
        setTimeout(function(){
          context.loadingTicket = false
          context.$store.commit('mutUserTickets', 'error')
        }, 1500)
      })
    },
    back(){
      this.$router.push('/')
    },
    getStudyPackage() {
      this.loadinglistPackage = true
      var context = this
      this.$store.dispatch('funcGetStudyPackage').then(res =>{
        context.loadinglistPackage = false
        for(var i =0; i < res.data.length; i++){
          if(res.data[i].is_active) context.subscribe.push(res.data[i])
          else context.notSubscribe.push(res.data[i])
        }
      }).catch(err =>{
        setTimeout(function(){
          context.loadinglistPackage = false
        }, 500)
      })
    },
    activatePackage(v){
      this.$router.push({query: {package: v}})
      this.$store.commit('setBuyWithTicket', [])
    },
    openFeature(v){
      if(v == 'app_tryout_instant') this.$router.push('/instant')
      if(v == 'app_scheduled_tryout') this.$router.push('/tryout-group')
      if(v == 'app_itembank') this.$router.push('/item-bank')
      if(v == 'app_video') this.$router.push('/video-pembelajaran')
    }
  },
  created() {
    this.reloadTicket()
    this.getStudyPackage()
    // this.checkPremium()
  },
  filters: {
    convDate(n) {
      var a = moment(n)
      
      var b = a.format('DD MMMM YYYY')
      return b
    }
  }
}
</script>
